import { RibbonComponent } from './shared/ribbon/ribbon.component';
import { Component, VERSION, DOCUMENT, inject, signal } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { DataService } from './services/data.service';
import { HammerModule } from '@angular/platform-browser';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule, RibbonComponent, NgbModule, FormsModule, ReactiveFormsModule, MatCardModule, MatButtonModule, MatFormFieldModule, FontAwesomeModule, HammerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private document = inject<Document>(DOCUMENT);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  hideRibbonSig = signal(false);

  dataService = inject(DataService);

  public title = 'skiworld-rental';
  public version = VERSION.full;

  constructor() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
    ).subscribe(() => {
      let r = this.route;
      while (r.firstChild) r = r.firstChild;         // bis zur aktivsten Child-Route durchgehen
      this.hideRibbonSig.set(!!r.snapshot.data['hideRibbon']);
    });
  }
}
